var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H15M5 4.5H1M21 15.5H17M7 15.5H1M12.5 4.5C12.5 6.433 10.933 8 9 8C7.067 8 5.5 6.433 5.5 4.5C5.5 2.567 7.067 1 9 1C10.933 1 12.5 2.567 12.5 4.5ZM16.5 15.5C16.5 17.433 14.933 19 13 19C11.067 19 9.5 17.433 9.5 15.5C9.5 13.567 11.067 12 13 12C14.933 12 16.5 13.567 16.5 15.5Z",
    stroke: "#1C1A1A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.65b5b1f58bfe3a296796aefb9fa8b459.svg";
export { ForwardRef as ReactComponent };